import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    container: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: 120,
        gridGap: 20,
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr 1fr",
        },
        [theme.breakpoints.down("xs")]: {
            gridTemplateColumns: "1fr",
            "& > $minor": {display: "none"},
        },
    },
    minor: {},
}))
